import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        apiUrl:
            process.env.NODE_ENV === 'production'
                ? process.env.MIX_COSCDA_CONSOLE_API_PROD
                : process.env.MIX_COSCDA_CONSOLE_API_LOCAL,
        filters: {},
        totalProviders: 0,
        providers: [],
        nextPageUrl: null,
        loading: false,
        filterSelections: {},
        searchedProviders: [],
        totalLocations: 0,
        locations: [],
        searchedLocations: [],
    },

    mutations: {
        setFilters(state, filters) {
            state.filters = filters;
        },

        setProviders(state, providers) {
            state.totalProviders = providers.total;
            state.providers = providers.data;
            state.nextPageUrl = providers.next_page_url;
        },

        pushProviders(state, providers) {
            state.providers.push(...providers.data);
            state.nextPageUrl = providers.next_page_url;
        },

        setLoading(state, loading) {
            state.loading = loading;
        },

        setLocations(state, locations) {
            state.totalLocations = locations.length;
            state.locations = locations;
        },
    },

    actions: {
        getLocations({state, commit}, params = {}) {
            commit('setLoading', true);
            axios.get(state.apiUrl + '/locations', {params}).then(({data}) => {
                commit('setLocations', data);
                commit('setLoading', false);
            });
        },
    },
});
